import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate } from 'react-router-dom';
import { useFindLoad } from 'hooks/useFindLoad';
import { settingsActions } from 'store/settings';
import { changePasswordSchema } from 'validationSchemes/userChangePassword';
import { SettingsPageLayout } from 'Layout/SettingsPageLayout';
import { LoadingButton } from 'components';
import { Form, BackSubmitBlock, EditUserInfo, FormButton } from './styled';
import { CHANGE_PASSWORD } from 'store/settings/types';
import { ROUTES } from 'utils/routeNames';
import { Images } from 'assets/images';
import {
  INPUT_PASSWORD_TYPE,
  INPUT_TEXT_TYPE,
  OLD_PASSWORD,
  PASSWORD,
  PASSWORD_CONFIRMATION,
} from 'utils/constant';
import {
  ErrorMessage,
  InputBlock,
  PasswordVisibleIcon,
  StyledInput,
} from 'components/inputs/ChangeInput/styled';

export const PasswordEdit = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'all',
    resolver: yupResolver(changePasswordSchema),
  });

  const [passwordVisibility, setPasswordVisibility] = useState({
    old_password: INPUT_PASSWORD_TYPE,
    password: INPUT_PASSWORD_TYPE,
    password_confirmation: INPUT_PASSWORD_TYPE,
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoading = useFindLoad(CHANGE_PASSWORD);

  const handleChangeInputType = (type) => {
    setPasswordVisibility((prev) => ({
      ...prev,
      [type]:
        passwordVisibility[type] === INPUT_PASSWORD_TYPE
          ? INPUT_TEXT_TYPE
          : INPUT_PASSWORD_TYPE,
    }));
  };

  const handleCancel = () => {
    navigate(ROUTES.HOME);
  };

  const onSubmit = (data) => {
    if (Object.keys(data).length) {
      dispatch(settingsActions.changePassword(data));
    }
  };

  return (
    <SettingsPageLayout>
      <EditUserInfo id="password-edit">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <InputBlock>
            <StyledInput
              placeholder="Current Password"
              type={passwordVisibility.old_password}
              error={errors?.old_password?.message}
              {...register(OLD_PASSWORD)}
            />
            <PasswordVisibleIcon
              src={
                passwordVisibility.old_password === INPUT_PASSWORD_TYPE
                  ? Images.passwordClosedEye
                  : Images.passwordOpenedEye
              }
              onClick={() => handleChangeInputType(OLD_PASSWORD)}
            />
            <ErrorMessage>{errors?.old_password?.message ?? null}</ErrorMessage>
          </InputBlock>

          <InputBlock>
            <StyledInput
              placeholder="New Password"
              type={passwordVisibility.password}
              error={errors?.password?.message}
              {...register(PASSWORD)}
            />
            <PasswordVisibleIcon
              src={
                passwordVisibility.password === INPUT_PASSWORD_TYPE
                  ? Images.passwordClosedEye
                  : Images.passwordOpenedEye
              }
              onClick={() => handleChangeInputType(PASSWORD)}
            />
            <ErrorMessage>{errors?.password?.message ?? null}</ErrorMessage>
          </InputBlock>

          <InputBlock>
            <StyledInput
              placeholder="Confirm New Password"
              type={passwordVisibility.password_confirmation}
              error={errors?.password_confirmation?.message}
              {...register(PASSWORD_CONFIRMATION)}
            />
            <PasswordVisibleIcon
              src={
                passwordVisibility.password_confirmation === INPUT_PASSWORD_TYPE
                  ? Images.passwordClosedEye
                  : Images.passwordOpenedEye
              }
              onClick={() => handleChangeInputType(PASSWORD_CONFIRMATION)}
            />
            <ErrorMessage>{errors?.password_confirmation?.message}</ErrorMessage>
          </InputBlock>

          <BackSubmitBlock>
            <FormButton onClick={handleCancel}>Cancel</FormButton>
            <LoadingButton loading={isLoading} name="Save Changes" />
          </BackSubmitBlock>
        </Form>
      </EditUserInfo>
    </SettingsPageLayout>
  );
};
